import type { StreamingWarningEvent } from '@/lib/streamingClient';

/**
 * User-facing text for a streaming dictation warning, or null when the
 * event needs no toast (a reconnect only clears stale provisional text).
 */
export const getStreamingWarningMessage = (event: StreamingWarningEvent): string | null => {
  switch (event.kind) {
    case 'final_failed':
      return event.audio_recovered
        ? 'Hluti upptökunnar náði ekki að umritast í rauntíma. Hann er umritaður aftur með hefðbundinni umritun.'
        : 'Hluti upptökunnar náði ekki að umritast. Farðu yfir textann.';
    case 'stream_fallback':
      return event.audio_recovered
        ? 'Rauntímaumritun rofnaði. Upptakan heldur áfram með hefðbundinni umritun.'
        : 'Rauntímaumritun rofnaði og hluti upptökunnar gæti vantað. Farðu yfir textann.';
    default:
      return null;
  }
};
